export const environment = {
  production: true,

  // 🆕 FSH-97: site key de Google reCAPTCHA v2 para /soporte y /requerimiento.
  // Pega aquí la site key de PROD para activar el captcha. Vacío = omitido.
  recaptchaSiteKey: '6Le1sQcuAAAAAMXIhM76YwOSbdmO0akWBydZgiA1',

  // pusherKey: 'a10e229a150dfd4ebfce',
  // openaiKey: "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",  // Para ChatGPT

  pusherKey: 'a10e229a150dfd4ebfce',
  openaiKey: "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",  // Para ChatGPT
  //iconsUrl: "https://storage.googleapis.com/f2rt-assets/f2rtnew/styles.css",
  iconsUrl: "assets/stylesicon.css",

  assetsUrl: "https://api.vivo-flight.com/api/attachments/assets/download", // 🔧 FSH-77 F4: assets (branding/iconos) servidos por el API
  baseUrl: "https://api.vivo-flight.com/api/", // Base de datos Prductivo (Rama: Master)

  googleMaps: {
    apiKey: 'AIzaSyAeti2mPpKGTfdO2Nb6H9-j2Mi9KCgEHd8',
    options: {
      region: 'CO',
      language: 'es',
      libraries: ['places'],
    }
  },
  openWeatherMap: {
    apiKey: 'e1748bb9d7cc7c91d5a9623d00bcbfef',
    baseUrl: 'https://tile.openweathermap.org/map'
  },
  // ============================================================
  // 🆕 INICIO: OpenAIP Configuration - 2026-01-13
  // ============================================================
  openAip: {
    apiKey: '0f72033c6fd1f69ad60e254b4cb36afc',
    tilesUrl: 'https://api.tiles.openaip.net/api/data',
    coreApiUrl: 'https://api.core.openaip.net/api',
    subdomains: ['a', 'b', 'c']
  },
  mapbox: {
    accessToken: 'pk.eyJ1IjoibmlsYW9uMDMzMCIsImEiOiJjbWtiamozdW0wNDZ2M2Zwb2NpOHcyd3JxIn0.WyrSWd72KEuReRUQpiENBg'
  }
  // ============================================================
  // 🆕 FIN: OpenAIP Configuration
  // ============================================================
};